import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Hook to load CMS content for a page with local fallback defaults.
 * @param {string} pageSlug - The page identifier (e.g. 'consulting')
 * @param {object} defaults - Fallback content keyed by section id
 * @returns {object} Merged content (CMS overrides defaults)
 */
export const useCmsContent = (pageSlug, defaults) => {
  const [content, setContent] = useState(defaults);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/site-content/${pageSlug}`);
        if (!cancelled && data && Object.keys(data).length > 0) {
          setContent(prev => {
            const merged = { ...prev };
            for (const [key, val] of Object.entries(data)) {
              if (val && typeof val === 'object' && !Array.isArray(val)) {
                merged[key] = { ...(prev[key] || {}), ...val };
              } else {
                merged[key] = val;
              }
            }
            return merged;
          });
        }
      } catch {
        // Silently use defaults
      }
    };
    load();
    return () => { cancelled = true; };
  }, [pageSlug]);

  return content;
};
